export var AppConfig = {
    appName: process.env.APP_NAME || 'Huddle Maps',
    environment: process.env.NODE_ENV || 'development',
    apiBaseUrl: process.env.API_BASE_URL || '',
    graphQlEndpoint: process.env.GRAPHQL_ENDPOINT || '',
    googleApiKey: process.env.GOOGLE_API_KEY || '',
    googleApiKeyName: process.env.GOOGLE_API_KEY_NAME || '',
    googleMapId: process.env.GOOGLE_MAP_ID || '',
};
